import React from "react";
import { Link, useLocation } from "react-router-dom";
import GetPath from "@Helpers/GetPath";
import { ROOT } from "@Shared/Paths/Customer";
import { ChevronRight } from "../../../../Supplier/Pages/PredictInstant/components/icons";
import iconStyles from "../../../../Supplier/Pages/PredictInstant/components/icons/index.module.scss";
import breadcrumbStyles from "../../../../Supplier/Pages/PredictInstant/components/PredictInstantBreadcrumb/index.module.scss";
import styles from "./DealDetailBreadcrumb.module.scss";
export default () => {
    const location = useLocation();
    const current = location.state?.supplierName ?? "Deal detail";
    return (React.createElement("div", { className: `${breadcrumbStyles.breadcrumb} ${breadcrumbStyles.embedded}` },
        React.createElement("div", { className: breadcrumbStyles.trail },
            React.createElement(Link, { to: GetPath(ROOT), className: `${breadcrumbStyles.parent} ${styles.link}` }, "Your Dashboard"),
            React.createElement("span", { className: breadcrumbStyles.chevronWrap },
                React.createElement(ChevronRight, { className: `${iconStyles.icon} ${iconStyles.chevron}` })),
            React.createElement("span", { className: `${breadcrumbStyles.current} ${styles.current}` }, current))));
};
